import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let routes = [{
    path: '/',
    redirect: "/login"
},
{
    path: '/login',
    name: 'Login',
    component: () => import( /* webpackChunkName: "login" */ '../views/loign/Login.vue')
},
{
    path: '/SchoolMngShowImg',
    name: 'SchoolMngShowImg',
    component: () => import( /* webpackChunkName: "SchoolMngShowImg" */ '../views/personal/schoolMng/SchoolMngShowImg.vue')
}
]

// 引入路由
import area_router from './area_router';

// 获取本地信息
let webUserInfo = {};
if (localStorage.getItem('webUserInfo')) {
    webUserInfo = JSON.parse(localStorage.getItem('webUserInfo'))
}
// 判断该用户是市或区
if (webUserInfo.client_type == 1) {
    // 赋值市路由操作
} else {
    // 赋值区路由操作
}
//路由合并
routes = routes.concat(area_router)


const router = new VueRouter({
    routes,
    // mode: "history",

    // scrollBehavior: 解决路由跳转时让滚动条置顶
    scrollBehavior(to, from, savedPosition) {
        // console.log(savedPosition,'43')  
        console.log(to, '47')
        if (savedPosition) {
            return savedPosition
        } else if (to.meta.scrollTop == 1) {
            // 滚动条置顶
            return {
                x: 0,
                y: 0
            }
        }
    }
})

router.beforeEach((to, from, next) => {
    let webUserInfo = JSON.parse(localStorage.getItem("webUserInfo"));
    // console.log(webUserInfo,'46');
    if (!webUserInfo && to.path !== '/login') {
        return next("/login");

    } else {
        next();
    }
    // scrollBehavior(to, from, savedPosition) {
    //     console.log(savedPosition,'43')
    //     if(savedPosition) {
    //         return savedPosition
    //     } else {
    //         return {
    //             x: 0,
    //             y: 0
    //         }
    //     }
    // }

})


// 解决Vue 路由跳转报错 Error: Avoided redundant navigation to current location: "/XXX".
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 解决Loading chunk {n} failed的报错
router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    console.log(targetPath, '92');
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});


export default router